import { render, staticRenderFns } from "./DragItem.vue?vue&type=template&id=3b77fac6&lang=html&"
import script from "./DragItem.vue?vue&type=script&lang=js&"
export * from "./DragItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports